export function mergeObject(toObj, fromObj){
    if (toObj !== undefined && fromObj !== undefined)
    {
         for (const key in fromObj) {
            if (fromObj.hasOwnProperty(key)) {
                toObj[key] = fromObj[key];
            }
        }
    }
    return toObj;
}

export function formDataToPayload(inputData, row, table){
    const tableColumnMap = new Map(table.getAllColumns().map(d => [d.id, d]));
    let payload = {};
    let updatedRow = {};
    for (const key in row.original) {               
        let columnDef = tableColumnMap.has(key) ? tableColumnMap.get(key).columnDef : null;

        updatedRow[key] = row.original[key];

        if (inputData.hasOwnProperty(key) && inputData[key] !== '') {            
            if (columnDef !== null && tableColumnMap.has(key) && (columnDef.visibleInShowHideMenu === undefined || columnDef.visibleInShowHideMenu))
            {                
                updatedRow[key] = inputData[key];
            }

            payload[key] = inputData[key];
            if (columnDef !== null && columnDef.dataType === 'boolean')
            {            
                payload[key] = inputData[key] === 'on' ? true : false;
            } 
        }
        else {
            updatedRow[key] = null;
        }
    }
    
    return { payload, updatedRow };
}